import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bool, func } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { fetchDashboardUsers } from '@redux/dashboardUsers/actions';
import { selectDashboardUsers } from '@redux/dashboardUsers/reducers';
import SingleSelectModal from '@components/SingleSelectModal';

function SelectDashboardUser({ visible, onCancel, onSubmit }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, dashboardUsers] = useSelector(selectDashboardUsers);

  useEffect(() => {
    dispatch(fetchDashboardUsers());
  }, [dispatch]);

  const filterFunc = (value, comparator) =>
    comparator(`${value.firstName} ${value.lastName}`) || comparator(value.email);

  const columns = useMemo(
    () => [
      {
        title: t('common:name'),
        render: record => `${record.firstName} ${record.lastName}`,
      },
      {
        title: t('common:email'),
        render: record => record.email,
      },
    ],
    [t],
  );

  return (
    <SingleSelectModal
      columns={columns}
      dataSource={dashboardUsers}
      filterFunc={filterFunc}
      loading={loading}
      primaryKey="id"
      title={t('common:modals.SelectUser.title')}
      visible={visible}
      onCancel={onCancel}
      onSubmit={onSubmit}
    />
  );
}

SelectDashboardUser.propTypes = {
  visible: bool,
  onCancel: func.isRequired,
  onSubmit: func.isRequired,
};

SelectDashboardUser.defaultProps = {
  visible: false,
};

export default SelectDashboardUser;
